import { render, staticRenderFns } from "./SliderDishes.vue?vue&type=template&id=5e416956"
import script from "./SliderDishes.vue?vue&type=script&lang=js"
export * from "./SliderDishes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports